// removed by extract-text-webpack-plugin
module.exports = {"row":"CardComparisonRow__row","arrow-container":"CardComparisonRow__arrow-container","arrowContainer":"CardComparisonRow__arrow-container","arrows-button":"CardComparisonRow__arrows-button","arrowsButton":"CardComparisonRow__arrows-button","left":"CardComparisonRow__left","cell":"CardComparisonRow__cell","cell-with-arrows":"CardComparisonRow__cell-with-arrows","cellWithArrows":"CardComparisonRow__cell-with-arrows","right":"CardComparisonRow__right"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/CardComparisonRow/CardComparisonRow.css
// module id = 1310
// module chunks = 8